import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_j",
  x2: "58.779",
  y1: "-100",
  y2: "-80.902",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ffce00",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fb9600",
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_h",
  x1: "58.779",
  x2: "95.106",
  y1: "-80.902",
  y2: "-30.902",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fb9600",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#e25335",
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_g",
  x1: "95.106",
  x2: "95.106",
  y1: "-30.902",
  y2: "30.902",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#e25335",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#de349e",
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_f",
  x1: "95.106",
  x2: "58.779",
  y1: "30.902",
  y2: "80.902",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#de349e",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#bf2fdc",
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_e",
  x1: "58.779",
  x2: "0",
  y1: "80.902",
  y2: "100",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#bf2fdc",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5d33d5",
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_d",
  x2: "-58.779",
  y1: "100",
  y2: "80.902",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5d33d5",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b7cd7",
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_c",
  x1: "-58.779",
  x2: "-95.106",
  y1: "80.902",
  y2: "30.902",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#2b7cd7",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#33c3dd",
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_b",
  x1: "-95.106",
  x2: "-95.106",
  y1: "30.902",
  y2: "-30.902",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#33c3dd",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32d9a1",
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_a",
  x1: "-95.106",
  x2: "-58.779",
  y1: "-30.902",
  y2: "-80.902",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#32d9a1",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3fcb2a",
  offset: "1"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "alc_i",
  x1: "-58.779",
  x2: "0",
  y1: "-80.902",
  y2: "-100",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3fcb2a",
  offset: "0"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#ffce00",
  offset: "1"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(100,100)",
  fill: "none",
  strokeWidth: "40"
}, /*#__PURE__*/React.createElement("path", {
  d: "m0-100a100 100 0 0 1 58.779 19.098",
  stroke: "url(#alc_j)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58.779-80.902a100 100 0 0 1 36.327 50",
  stroke: "url(#alc_h)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m95.106-30.902a100 100 0 0 1 0 61.804",
  stroke: "url(#alc_g)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m95.106 30.902a100 100 0 0 1 -36.327 50",
  stroke: "url(#alc_f)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58.779 80.902a100 100 0 0 1 -58.779 19.098",
  stroke: "url(#alc_e)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 100a100 100 0 0 1 -58.779 -19.098",
  stroke: "url(#alc_d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-58.779 80.902a100 100 0 0 1 -36.327 -50",
  stroke: "url(#alc_c)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-95.106 30.902a100 100 0 0 1 0 -61.804",
  stroke: "url(#alc_b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-95.106-30.902a100 100 0 0 1 36.327 -50",
  stroke: "url(#alc_a)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m-58.779-80.902a100 100 0 0 1 58.779 -19.098",
  stroke: "url(#alc_i)"
}), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  attributeType: "xml",
  dur: "0.5s",
  from: "0",
  repeatCount: "indefinite",
  to: "360",
  type: "rotate"
}))), 'AnimatedLoadingColorful2', {
  viewBox: '-120 -120 240 240'
});